import { formatISO } from 'date-fns';
import { generateIdentifier } from './helpers';

export const prepareCustomerUser = (
  customerUser: {
    identifier?: string;
    externalId?: string | null;
    confirmed?: boolean;
    customer?: number;
    roles?: number[];
    level?: API_JSON;
  },
  user?: {
    id?: number;
    lastname?: string;
    firstname?: string;
    username?: string;
    email?: string;
    password?: string;
    confirmed?: boolean;
    status?: string;
    gender?: API_JSON;
    ethnicities?: API_JSON[];
  },
  onBoardUUID?: string
): MutationBody => ({
  data: {
    type: 'CustomersUsers',
    attributes: {
      ...(customerUser.identifier ? { identifier: customerUser.identifier } : {}),
      ...(customerUser.externalId ? { externalId: customerUser.externalId } : {}),
      ...(customerUser.confirmed ? { confirmed: customerUser.confirmed } : {})
    },
    relationships: {
      ...(customerUser.customer
        ? {
            customer: {
              data: { id: `/api/v2/customers/${customerUser.customer}`, type: 'Customer' }
            }
          }
        : {}),
      ...(user
        ? {
            user: {
              data: {
                lid: user?.id || customerUser.identifier,
                type: 'User'
              }
            }
          }
        : {}),
      ...(customerUser.roles
        ? {
            roles: {
              data: customerUser.roles.map((role) => ({
                id: `/api/v2/roles/${role}`,
                type: 'Role'
              }))
            }
          }
        : {}),
      ...(customerUser.level
        ? { level: { data: { id: `/api/v2/levels/${customerUser.level.id}`, type: 'Level' } } }
        : {}),
      ...(onBoardUUID
        ? {
            obfuscatedDatas: {
              data: [{ id: `/api/v2/obfuscated-datas/${onBoardUUID}`, type: 'ObfuscatedData' }]
            }
          }
        : {})
    }
  },
  ...(user
    ? {
        included: [
          {
            lid: user?.id || customerUser.identifier,
            type: 'User',
            attributes: {
              ...(user.email ? { email: user.email } : {}),
              ...(user.firstname ? { firstname: user.firstname } : {}),
              ...(user.lastname ? { lastname: user.lastname } : {}),
              ...(user.username ? { username: user.username } : {}),
              ...(user.password ? { password: user.password } : {}),
              ...(user.confirmed ? { confirmed: user.confirmed } : {}),
              ...(user.status ? { status: user.status } : {})
            },
            relationships: {
              ...(user.ethnicities
                ? {
                    ethnicities: user.ethnicities.map((e) => ({
                      id: `/api/v2/ethnicities/${e.id}`,
                      type: 'Ethnicity'
                    }))
                  }
                : {}),
              ...(user.gender
                ? {
                    gender: {
                      id: `/api/v2/genders/${user.gender.id}`,
                      type: 'Gender'
                    }
                  }
                : {})
            }
          }
        ]
      }
    : {})
});

export const prepareCustomerUserOnboard = (roles: number[], onBoardUUID: string): MutationBody => ({
  data: {
    type: 'CustomersUsers',
    attributes: {},
    relationships: {
      roles: {
        data: roles.map((role) => ({
          id: `/api/v2/roles/${role}`,
          type: 'Role'
        }))
      },
      obfuscatedDatas: {
        data: [
          {
            id: `/api/v2/obfuscated-datas/${onBoardUUID}`,
            type: 'ObfuscatedData'
          }
        ]
      }
    }
  }
});

export const preparePostCustomerUserOnboard = (
  roles: number[],
  onBoardUUID: string,
  customer: number,
  user: number
): MutationBody => ({
  data: {
    type: 'CustomersUsers',
    attributes: {
      confirmed: true,
      confirmedAt: formatISO(new Date()),
      identifier: generateIdentifier(customer, user),
      roles: roles.map((role) => ({
        id: `/api/v2/roles/${role}`,
        type: 'Role'
      })),
      obfuscatedDatas: [
        {
          id: `/api/v2/obfuscated-datas/${onBoardUUID}`,
          type: 'ObfuscatedData'
        }
      ],
      customer: {
        id: `/api/v2/customers/${customer}`,
        type: 'Customer'
      },
      user: {
        id: `/api/v2/users/${user}`,
        type: 'User'
      }
    }
  }
});
